var render, staticRenderFns
import script from "./Badge.vue?vue&type=script&lang=ts&"
export * from "./Badge.vue?vue&type=script&lang=ts&"
import style0 from "./Badge.vue?vue&type=style&index=0&id=2585b716&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports